;(() => {
  const createRequest = require('airship/modules/request2/ua-request')
  const ractiveModal = require('airship/widgets/ractive-modal')
  const reportError = require('airship/modules/error-reporting')

  const modalTemplate = require('./product-research.ract')

  function showInProductRecruitingModal() {
    const modal = ractiveModal(modalTemplate)
    const request = createRequest()
    const data = {}

    modal.open()

    modal.view.on('save', saveForm)
    modal.view.on('submit', submitForm)
    modal.view.on('close', closeForm)

    function saveForm(rev) {
      rev.original.stopPropagation()
      rev.original.preventDefault()

      const formData = new FormData(
        document.getElementById('product-research-modal') //mustang-serial-message-modal
      )

      formData.forEach((value, key) => {
        data[key] = value
      })

      modal.view.set('saved', true)
    }

    function submitForm(rev) {
      rev.original.stopPropagation()
      rev.original.preventDefault()
      modal.view.set('pending', true)
      modal.view.set('saved', false)

      data.scheduleCall = rev.node.value
      data.url = window.location.href

      // For reasons I've given up on understanding; our requests
      // module is explicitly setting the content type to application/json
      // when formData is supplied, and for other reasons, you can't get
      // the boundary name of formdata in a direct way, so I can't set
      // the content type manually, either; w/e -- let's just send JSON
      request
        .post({
          url: '/jsapi/product-research/submit/',
          body: data
        })
        .then(() => {
          if (rev.node.value === 'yes') {
            modal.view.set('submitted', true)
            modal.view.set('pending', false)
          } else {
            modal.close()
          }
        })
        .catch(err => {
          reportError(err, __filename)
          modal.view.set('error', true)
        })
    }

    function closeForm() {
      modal.close()
    }
  }

  window.showInProductRecruitingModal = showInProductRecruitingModal
})()
